import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// Re-run the auto-triage classifier on captures that already carry a payload.
// ---------------------------------------------------------------------------
// `triageWorkCapture` is an onCreate trigger that skips any doc already holding
// a `proposedTriage`, so a FAILED classification is otherwise permanent — the
// 2026-07-22 API-key revocation stranded 22 captures behind
// `needsInfoNote: 'auto-triage API error'` that rotating the key could not
// reach. `retriageTask` is the recovery path (admin/owner only).
//
// Accepts one id or up to 25, and returns { requested, succeeded, results[] }.
export async function retriageTasks(taskIds) {
	const ids = Array.isArray(taskIds) ? taskIds : [taskIds];
	const callable = httpsCallable(functions, 'retriageTask');
	const res = await callable(ids.length === 1 ? { taskId: ids[0] } : { taskIds: ids });
	return res.data;
}

// Commit a proposal onto its task (Slice 2). Applies the fields the diff says
// would change, creates the proposed sub-tasks as real child tasks, and stamps
// the task triaged — one atomic batch server-side, so it never half-lands.
//
// Employee-or-admin (not admin-only like retriage): no API budget is spent, and
// it is the same population that can already edit these fields by hand.
//
// `withSubtasks: false` commits the fields only. Returns
// { ok, applied[], kept[], verdicts, subtasksCreated }.
export async function approveTriage(taskId, { withSubtasks = true } = {}) {
	const callable = httpsCallable(functions, 'approveTriage');
	const res = await callable({ taskId, withSubtasks });
	return res.data;
}

const triageService = { retriageTasks, approveTriage };
export default triageService;
